export const formDataGalleryCreate = (defaultData?: GalleryFormData): FormParams => {
  return {
    items: {
      upperFields: [
        {
          element: 'input',
          type: 'text',
          id: 'title',
          placeHolder: 'Título da galeria',
          label: 'Título da galeria',
          defaultValue: defaultData ? defaultData.formData.title : null,
        },
        {
          element: 'textarea',
          id: 'description',
          placeHolder: 'Descrição da galeria',
          label: 'Descrição da galeria',
          rows: 5,
          defaultValue: defaultData ? defaultData.formData.description : null,
        },
        {
          element: 'input',
          type: 'date',
          id: 'exhibitionOn',
          label: 'Data',
          // exhibitionOn já vem como "YYYY-MM-DD", que é exatamente o formato do
          // input date. Passar por new Date()/toInputDate reintroduz erro de fuso.
          defaultValue: defaultData ? defaultData.formData.exhibitionOn : null,
        },
      ],
      bottomFields: [
      ],
    },
    style: 'gray',
  };
};
